import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Vacancy } from '@mkp/vacancy/models';
import { CartDto } from '@mkp/publication/models';

export const NotificationGatewayActions = createActionGroup({
  source: 'Notification Gateway',
  events: {
    'Unverified Checkout Success': props<{
      vacancy: Vacancy;
      cart: CartDto;
    }>(),
    'Unverified Checkout Failure': emptyProps(),
    'Salary Partnership Success': emptyProps(),
    'Salary Partnership Failure': emptyProps(),
  },
});
